import { useNavigate } from 'react-router-dom'
import XButton from './common/XButton'

const ProfileFormActionButton = ({
  cancelPath = "",
  onSave,
  disabled = false,
  saveText = "Save Changes",
  cancelText = "Cancel"
}) => {
  const navigate = useNavigate()

  return (
    <div className="btns text-right">
      <XButton
        variant="outlinePrimary"
        className="mr-3!"
        onClick={() => navigate(cancelPath)}
      >
        {cancelText}
      </XButton>
      <XButton disabled={disabled} onClick={onSave}>
        {saveText}
      </XButton>
    </div>
  )
}

export default ProfileFormActionButton